import api from "./Api";

class GrupoService {
  GetGrupo(payload) {
    return api.get("/v1/grupo/" + payload).then((response) => {
      return response.data;
    });
  }

  PostGrupo(payload) {
    return api.post("/v1/grupo/", payload).then((response) => {
      return response.data;
    });
  }

  PutGrupo(payload) {
    return api.put("/v1/grupo/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteGrupo(payload) {
    return api.delete("/v1/grupo/" + payload).then((response) => {
      return response.data;
    });
  }

  GetGrupoOData(payload) {
    return api.get("/OData/Grupo" + payload).then((response) => {
      return response.data;
    });
  }

  Validate(payload) {
    return api.post("/v1/grupo/Validate/", payload).then((response) => {
      return response.data;
    });
  }

  Converter(payload) {
    return api.post("/v1/grupo/Converter/", payload).then((response) => {
      return response.data;
    });
  }
}

export default new GrupoService();
